import StopAddressWhenEdit from 'components/form/StopAddressWhenEdit/styled';

export default StopAddressWhenEdit;
